import React from 'react';
import { FileAddOutlined } from '@ant-design/icons';
import { Button, Col, message, Row, Spin, Upload } from 'antd';
import { useNavigate } from 'react-router-dom';
import Resume_Checker_Image from './assets/image_checker_image.png';
import './App.css';
import environment from './environment';
import { getToken } from './token.service';

const { Dragger } = Upload;

const UploadResume = () => {
  const [spinning, setSpinning] = React.useState(false);

  const navigate = useNavigate();

  const props = {
    name: 'file',
    multiple: true,
    action: `${environment.api_url}/api/resume-analyser/upload`,
    headers: {
      Authorization: `Basic ${getToken()}`,
    },
    onChange(info) {
      setSpinning(true);
      const { status } = info.file;
      if (status !== 'uploading') {
        console.log(info.file.response);
      }
      if (status === 'done') {
        setSpinning(false);
        message.success(`${info.file.name} file uploaded successfully.`);
        localStorage.setItem('resumeData', JSON.stringify(info.file.response));
        navigate('/report'); // Navigate to the desired route
      } else if (status === 'error') {
        setSpinning(false);
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    onDrop(e) {
      setSpinning(true);
      console.log('Dropped files', e.dataTransfer.files);
    },
  };

  const contentStyle = {
    padding: 50,
    background: 'rgba(0, 0, 0, 0.05)',
    borderRadius: 4,
  };
  const content = <div style={contentStyle} />;

  return (
    <>
      <Spin tip="Hang tight! We're diving deep into your resume to uncover insights" spinning={spinning} fullscreen size="large">
        {content}
      </Spin>

      <div style={{ padding: '40px' }}>
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12} style={{ textAlign: 'center' }}>
            <h1>AI-Powered Resume Analysis</h1>
            <img src={Resume_Checker_Image} alt="Example" height={300} />
            <h2>Elevate Your Resume with Cutting-Edge AI</h2>
          </Col>
          <Col xs={24} md={12}>
            <Dragger {...props} className='upload_class'>
              <p className="ant-upload-drag-icon" style={{ marginBottom: '35px' }}>
                <FileAddOutlined />
              </p>
              <Button type="primary" shape="round" size='large'>
                <span style={{ fontSize: '20px' }}>Upload Resume</span>
              </Button>
              <h3 style={{ color: '#8a8a8a', fontWeight: 600, fontSize: "1.25rem" }}>or drop a resume</h3>
              <span className='light-grey-text'>Accepted file formats are PDF and DOC</span>
            </Dragger>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default UploadResume;